/* The design's .btn and .icon-btn (DesignReference/Main.dc.html), mirroring mobile/src/components/ui/Button.tsx. */
.button {
  --button-bg: var(--primary);
  --button-fg: var(--on-primary);
  --button-border: transparent;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: var(--control-height);
  padding: var(--space-4) var(--space-6);
  font-family: var(--font-heading);
  font-size: var(--text-md); /* 16px (specs/003 #9) */
  font-weight: var(--weight-bold);
  line-height: var(--leading-tight);
  text-decoration: none;
  background: var(--button-bg);
  color: var(--button-fg);
  border: var(--border-width-strong) solid var(--button-border);
  border-radius: var(--radius-md);
  cursor: pointer;
  transition:
    filter var(--duration-fast) var(--ease-standard),
    transform var(--duration-fast) var(--ease-standard);
}

.button:hover {
  filter: brightness(0.96);
}

.button:active {
  transform: scale(0.98);
}

.button:disabled,
.button[aria-disabled='true'] {
  opacity: var(--disabled-opacity);
  cursor: not-allowed;
  filter: none;
  transform: none;
}

.button[data-variant='secondary'] {
  --button-bg: var(--secondary);
  --button-fg: var(--on-secondary);
}

.button[data-variant='outline'] {
  --button-bg: transparent;
  --button-fg: var(--text);
  --button-border: var(--border);
}

.button[data-variant='ghost'] {
  --button-bg: transparent;
  --button-fg: var(--primary-strong);
}

.button[data-variant='success'] {
  --button-bg: var(--success-strong);
  --button-fg: var(--on-success-strong);
}

.button[data-variant='danger'] {
  --button-bg: var(--danger);
}

.button[data-size='sm'] {
  min-height: var(--tap-min);
  padding: var(--space-2) var(--space-4);
  font-size: var(--text-sm);
}

.block {
  width: 100%;
}

.spinner {
  width: 1em;
  height: 1em;
  border: var(--border-width-strong) solid currentcolor;
  border-right-color: transparent;
  border-radius: var(--radius-pill);
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.iconButton {
  --icon-button-bg: var(--surface);
  --icon-button-fg: var(--text);

  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: var(--icon-button-size, var(--tap-min));
  height: var(--icon-button-size, var(--tap-min));
  padding: 0;
  background: var(--icon-button-bg);
  color: var(--icon-button-fg);
  border: var(--border-width) solid var(--border);
  border-radius: var(--radius-pill);
  cursor: pointer;
}

.iconButton:hover {
  background: var(--surface-2);
}

.iconButton[data-variant='plain'] {
  --icon-button-bg: transparent;

  border-color: transparent;
}

.iconButton[data-variant='primary'] {
  --icon-button-bg: var(--primary);
  --icon-button-fg: var(--on-primary);

  border-color: transparent;
}

.iconButton[data-variant='danger'] {
  --icon-button-bg: var(--end-call);
  --icon-button-fg: var(--on-end-call);

  border-color: transparent;
}

.iconButton[aria-pressed='true'] {
  --icon-button-bg: var(--text);
  --icon-button-fg: var(--bg);
}

.iconButton:disabled {
  opacity: var(--disabled-opacity);
  cursor: not-allowed;
}
